export function sortDevices(devices) {
  return [...devices].sort((left, right) => {
    const onlineDifference =
      Number(right.status === "online") - Number(left.status === "online");
    if (onlineDifference) return onlineDifference;
    return String(right.last_seen_at ?? "").localeCompare(
      String(left.last_seen_at ?? ""),
    );
  });
}

export function deviceSubtitle(device) {
  if (device.status === "online") {
    return device.active_workspace_name
      ? `Online · ${device.active_workspace_name}`
      : "Online · pronto para receber tarefas";
  }
  if (!device.last_seen_at) return "Offline";
  const date = new Date(device.last_seen_at);
  return Number.isNaN(date.getTime())
    ? "Offline"
    : `Offline · visto em ${date.toLocaleString("pt-BR")}`;
}
